import React from "react";
// import { Tab } from "extranet-component-library";
import BookingsContent from "../components/BookingsContent";
// import SanctionsContent from "../components/SanctionsContent";
import { useStores } from "../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import biciB from '../assets/img/cards/BICI_B.svg';

const MouTeBe = observer(() => {
  const { t } = useTranslation();
  const { moutebeStore } = useStores();
  const { bookings } = moutebeStore;
  // const [tabIndex, setTabIndex] = useState(0);

  // const onChangeTab = (tabIndx: number) => {
  //   setTabIndex(tabIndx);
  // };

  return (
    <>
      <div className="page-title-mobile">
        {t("moutebe").replace("/", " ")}
        <img src={biciB} alt="img" />
      </div>
      <div className="moutebe">
        <BookingsContent bookings={bookings} />
        {/* <Tab
          tabs={[
            {
              header: t("bookings_history"),
              content: <BookingsContent bookings={bookings} />,
            },
            {
              header: t("my_sanctions"),
              content: <SanctionsContent sanctions={sanctions} />,
            },
          ]}
          currentIndex={tabIndex}
          onTabChange={(tabIndx) => {
            onChangeTab(tabIndx);
          }}
        /> */}
      </div>
    </>
  );
});

export default MouTeBe;
